import { playersTypes } from '../constants/playersConstants';

const initialState = {
    owner: null,
    participants: [],
    online: []
};

const setOnline = (state, player) => {
    const result = [...state.online];

    if (result.reduce((acc, p) => (acc && p.email !== player.email), true)) {
        result.push(player);
    }

    return result;
}

const setOffline = (state, player) => {
    const result = [...state.online];
    return result.filter(p => (p.email !== player.email));
}


export const playersReducer = (state = initialState, action) => {
    switch (action.type) {
        case playersTypes.LOAD_PLAYERS:
            return {
                ...state,
                owner: action.owner === null ? state.owner : action.owner,
                participants: [...action.participants]
            };

        case playersTypes.ADD_PLAYERS:
            return {
                ...state,
                participants: [...state.participants, action.player]
            };

        case playersTypes.SET_ONLINE:
            return {
                ...state,
                online: setOnline(state, action.player)
            };

        case playersTypes.SET_OFFLINE:
            return {
                ...state,
                online: setOffline(state, action.player)
            };

        case playersTypes.RESET:
            return {
                ...state,
                ...initialState
            };


        default:
            return state;
    }
};